export function stripIban(input: string): string {
  return (input || '').replaceAll(/[^a-zA-Z0-9]/g, '').toUpperCase()
}

export function formatIban(input: string): string {
  const s = stripIban(input)
  return s.replaceAll(/(.{4})/g, '$1 ').trim()
}

// Mod-97 validation per IBAN spec
export function mod97Check(iban: string): boolean {
  const stripped = stripIban(iban)
  if (stripped.length < 5) return false
  // Move first four chars to the end
  const rearranged = stripped.slice(4) + stripped.slice(0, 4)
  // Replace letters with numbers A=10 ... Z=35
  const expanded = rearranged
    .split('')
    .map((ch) => {
      const code = ch.codePointAt(0)!
      if (code >= 65 && code <= 90) {
        return (code - 55).toString() // A -> 10
      }
      return ch
    })
    .join('')

  // Perform iterative mod97 to avoid big integers
  let remainder = 0n
  for (let i = 0; i < expanded.length; i += 7) {
    const part = expanded.slice(i, i + 7)
    const num = BigInt(remainder.toString() + part)
    remainder = num % 97n
  }
  return remainder === 1n
}

export function isValidIbanForCountry(iban: string): boolean {
  const stripped = stripIban(iban)
  if (stripped.length < 5) return false
  const country = stripped.slice(0, 2)
  // Basic country-specific length check for common countries
  const lengths: Record<string, number> = {
    DE: 22,
    CH: 21,
    AT: 20,
    FR: 27,
    ES: 24,
    NL: 18
  }
  if (lengths[country]) {
    if (stripped.length !== lengths[country]) return false
  }
  return mod97Check(stripped)
}
